import { translate } from "@/plugins/i18n";
import type BaseEnumType from "../../baseEnumType";
import Key from "@/app/types/common/key";
import { Maybe } from "@/components/utils/typeHelpers";


export class EnumWidgetDragType implements BaseEnumType {
  private static allValues: EnumWidgetDragType[] = []; // make sure this is top-most
  
  public static move = new EnumWidgetDragType(1, "Move", "enum_widget_drag_type_move");
  public static resize = new EnumWidgetDragType(2, "Resize", "enum_widget_drag_type_resize");
  
  public key: number;
  public value: string;
  public translationKey: string;

  private constructor(key: number, value: string, translationKey: string) {
    this.key = key;
    this.value = value;
    this.translationKey = translationKey;
    EnumWidgetDragType.allValues.push(this);
  }

  public get translation() { return translate(Key.fromString(this.translationKey)); }

  public isMove() { return this === EnumWidgetDragType.move; }
  public isResize() { return this === EnumWidgetDragType.resize; }

  public static getValues(): readonly EnumWidgetDragType[] {
    return EnumWidgetDragType.allValues;
  }

  public static getValuesExcept0(): readonly EnumWidgetDragType[] {
    return EnumWidgetDragType.allValues.filter((x) => x.key !== 0);
  }

  public static getByKey(key: number): EnumWidgetDragType {
    const found = EnumWidgetDragType.allValues.find(e => e.key === key);
    if (found === undefined) {
      throw new Error(`EnumWidgetDragType - Key not found: ${ key }`);
    }

    return found;
  }

  public static getByValue(name: string, def?: EnumWidgetDragType): EnumWidgetDragType {
    const found = name ? EnumWidgetDragType.allValues.find(e => e.value.toLowerCase() === name.toLowerCase()) : null;
    if (!found) {
      if (def) {
        return def;
      }
      throw new Error(`EnumWidgetDragType - Value not found: ${ name }`);
    }

    return found;
  }

  public equals(other: Maybe<EnumWidgetDragType>): boolean {
    return this.key === other?.key;
  }
}